import { Autocomplete, Box, Chip, TextField } from "@mui/material";
import type { FC } from "react";
import { type Control, Controller } from "react-hook-form";
import {
  personLabel,
  type Permissions,
  type PersonDetails,
} from "../../server/supabase-person-service";
import type { PermissionsFormType } from "../../types";

export const EmployeeSelect: FC<{
  control: Control<PermissionsFormType>;
  employees: PersonDetails[];
  existing?: Permissions;
}> = ({ control, employees, existing }) => {
  return (
    <Controller
      name="person_ids"
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          multiple={true}
          disabled={!!existing}
          id="employee-select"
          value={employees.filter((s) => field.value?.includes(s.id))}
          options={employees}
          renderOption={(renderProps, option) => (
            <Box component="li" {...renderProps} key={option.id}>
              {personLabel(option)}
            </Box>
          )}
          renderValue={(tagValue, getTagProps) =>
            tagValue.map((option, index) => (
              <Chip {...getTagProps({ index })} key={option.id} label={personLabel(option)} />
            ))
          }
          renderInput={(params) => (
            <TextField
              label="Select Employee(s)"
              variant="standard"
              {...params}
              helperText={error?.message}
              error={!!error}
              slotProps={{
                input: { ...params.InputProps, "data-testid": "employee-select" },
              }}
            />
          )}
          getOptionLabel={(option) => personLabel(option)}
          onChange={(_, v) => {
            field.onChange(v.map((x) => x.id));
          }}
        />
      )}
    />
  );
};
